import * as React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Modal, Form, Button, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import { motion } from "framer-motion";

const nl2br = require('react-nl2br');


export const Message = () => {
    const navigate = useNavigate();
  
    const location = useLocation();
    const [ittengo, setIttengo] = React.useState(location.state.ittengo);
    const [message, setMessage] = React.useState([]);
  
    const [isLoading, setIsLoading] = React.useState(true);
    const [isError, setIsError] = React.useState(false);
    
    const [show, setShow] = React.useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const handleChange = (event) => {
      setMessage(event.target.value);
    }
  
    const handleSubmit = (event) => {
      console.log(message);
      console.log(ittengo);
  
  
      fetch("https://" + process.env.REACT_APP_API_HOST + "/api/v1/gift/gift/", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          csrfmiddlewaretoken: '',
          campaign: 1,
          ittengo: ittengo.id,
          message: message
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoading(false);
  
          window.scrollTo(0, 0);

          navigate('/mothersday2022/done',
            { state: { ittengo: ittengo, message: message, giftId: result.id, expiredAt: result.expired_at }}
          );
        })
      .catch(
        (error) => {
          setIsLoading(false);
          setIsError(true);
          console.log(error);
        }
      )
  
      event.preventDefault();
    }
  
    return (
      <>
        <motion.div
          animate={{
            x: 0,
            opacity: 1
          }}
          initial={{
            x: 100,
            opacity: 0
          }}
          exit={{
            x: -100,
            opacity: 0
          }}
          transition={{
            duration: 0.2
          }}
        >
          <main>
            <h2 className="mb-4">2. メッセージを入力</h2>
  
  
            <Image src={ittengo.image} alt={ittengo.honkaku.title} fluid />
            <div className="mt-4">
              <Image src={ittengo.border_top} className="mb-3" fluid />
              <Form>
                <Form.Group>
                  <Form.Control as="textarea" rows={5} placeholder="お母さん、いつもありがとう！" required onChange={handleChange} />
                </Form.Group>
              </Form>
              <Image src={ittengo.border_bottom} fluid />
            </div>
  
            <div className="mt-5">
              <Link to="/mothersday2022/choose" className="btn btn-secondary">もどる</Link>
              <Button variant="warning" onClick={handleShow} className="ms-2">プレビューを表示</Button>
            </div>
          </main>
        </motion.div>
  
        <Modal show={show} onHide={handleClose} animation={true} fullscreen='sm-down' scrollable={true} size='xl'>
          <Modal.Header closeButton>
            <Modal.Title className="fs-6">（プレビュー）</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Image src={ittengo.image} alt={ittengo.honkaku.title} fluid />
            <div className="mt-4">
              <Image src={ittengo.border_top} className="mb-3" fluid />
              <p>{nl2br(message)}</p>
              <Image src={ittengo.border_bottom} fluid />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>もどる</Button>
            <Button variant="warning" onClick={handleSubmit}>
              この内容で作成する
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }